import departementTypes from './departementTypes';

const initialState = {
    loading: false,
    departements: [],
};

const departementReducer = (state = initialState, action: any) => {
    let nextState;

    switch (action.type) {
        
        case departementTypes.GET_DEPARTEMENTS:
            nextState = {
                ...state,
                loading: true,
            };
            return nextState || state;

        case departementTypes.SET_DEPARTEMENTS:
            nextState = {
                ...state,
                departements: action.payload,
                loading: false,
            };
            return nextState || state;
        
        default:
            return state;
    }
};

export default departementReducer;
